import { Case } from '../../../beans/Case';
import { Instance } from '../../../beans/Instance';
import { Lawyer } from '../../../beans/Lawyer';
import { Nomenclature } from '../../../beans/Nomenclature';
import { StatusesTask } from '../../../beans/StatusesTask';
import { TaskFrx } from '../../../beans/TaskFrx';
import { FrxBaseBean } from '../../../beans/frxbasebean';
import { WordTemplate } from '../../../beans/word-template';
import { BlockUiService } from '../../../services/blockui.service';
import { CaseService } from '../../../services/case.service';
import { NomenclatureService } from '../../../services/nomenclature.service';
import { TaskService } from '../../../services/task.service';
import { WordTemplateService } from '../../../services/word-template.service';
import { EditCaseComponent } from '../edit-case.component';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewContainerRef, Host, Input, ViewChild } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ModalDirective } from 'ngx-bootstrap';
import { StatusBean } from '../../../beans/StatusBean';
import { AuthService } from '../../../services/auth.service';
@Component({
	selector: 'app-edit-case-second-instance',
	templateUrl: './edit-case-second-instance.component.html',
	styleUrls: ['./edit-case-second-instance.component.scss']
})
export class EditCaseSecondInstanceComponent implements OnInit {

	private _caseid;

	errorMessage: string;

	message = '';
	addInstanceText = 'Добави нова инстанция на делото';
	instance: Instance;
	task: TaskFrx;
	selectedStatus: StatusesTask;

	oldInstances: Array<Instance> = new Array();
	lawyers: Array<Lawyer>;
	instancesTasks: Array<TaskFrx>;
	instances: Array<Nomenclature>;
	cities: Array<Nomenclature>;
	courts: Array<Nomenclature>;
	statuses: Array<Nomenclature>;
	statusesTask: Array<StatusesTask>;

	public colsTask = [
		{ title: 'Deadline', name: 'deadline', dataType: 'date' },
		{ title: 'Описание', name: 'opisanie' },
		{ title: 'Статус', name: 'statusTaskBG' },
		{ title: 'Отговорник', name: 'otgovornik', dataType: 'object', complexDataType: { object: true, displayValue: 'username' } }
	];
	public cols = [
		{ title: 'Създадено на°', name: 'createdDate', dataType: 'date' },
		{ title: 'Насрочено за', name: 'dataNasrochen', dataType: 'date' },
		{ title: 'Час', name: 'timeNasrochen' },
		{ title: 'Номер на гражданско дело', name: 'number' },
		{ title: 'Статус', name: 'status', dataType: 'object', complexDataType: { object: true, displayValue: 'name' } },
		{ title: 'Инстанция', name: 'instance', dataType: 'object', complexDataType: { object: true, displayValue: 'name' } },
		{ title: 'Град', name: 'city', dataType: 'object', complexDataType: { object: true, displayValue: 'name' } },
		{ title: 'Съд', name: 'court', dataType: 'object', complexDataType: { object: true, displayValue: 'name' } },
		{ title: 'Архивна Папка', name: 'archiveFolderName' },
		{ title: 'Бележка', name: 'note' },
		{ title: 'Лихва - неимуществ.', name: 'lihvaDate', dataType: 'date' },
		{ title: 'Главница - неимуществ.', name: 'glavnica', dataType: 'currency' },
		{ title: 'Лихва - имуществ.', name: 'lihvaImushtestvDate', dataType: 'date' },
		{ title: 'Главница - имуществ.', name: 'glavnicaImushtestv', dataType: 'currency' },
		{ title: 'Присъдени разноски', name: 'prisudeniRaznoski' },
		{ title: 'Разноски за ответната страна', name: 'raznoskiOtvetnaStrana', dataType: 'currency' },
		{ title: 'Съдия - докладчик', name: 'sudiaDokladchik' },
		{ title: 'Посредник', name: 'mediator' },
		{ title: 'Процент', name: 'percentage' },
		{ title: 'Съпpичиняване', name: 'suprichinjavane' },
		{ title: 'Приета сума /€/', name: 'prietaSuma', dataType: 'currency' }
	];

	// Word templates
	instTemplates: WordTemplate[] = [];
	selectedInstTemplate: WordTemplate = null;

	// Per-instance history modal
	@ViewChild('instanceHistoryModal') instanceHistoryModal: ModalDirective;
	isAdmin = false;
	selectedInstanceForHistory: any = null;

	constructor(
		private caseService: CaseService,
		private nomenclatureService: NomenclatureService,
		private blockUi: BlockUiService,
		private vcRef: ViewContainerRef,
		private taskService: TaskService,
		private datePipe: DatePipe,
		private wordTemplateService: WordTemplateService,
		private authService: AuthService,
		@Host() private parentComp: EditCaseComponent, ) {
		this.isAdmin = this.authService.isUserAdmin();
	}

	openInstanceHistory(row: any) {
		this.selectedInstanceForHistory = row;
		this.instanceHistoryModal.show();
	}

	closeInstanceHistory() {
		this.instanceHistoryModal.hide();
		this.selectedInstanceForHistory = null;
	}

	ngOnInit() {
		this.loadData();
		this.loadInstTemplates();
		this.instances = this.parentComp.instances;
		this.cities = this.parentComp.cities;
		this.courts = this.parentComp.courts;
		this.statuses = this.parentComp.statuses;
		this.statusesTask = this.parentComp.statusesTask;
		this.lawyers = this.parentComp.lawyers;
	}

	private loadData() {
		this.blockUi.start(this.vcRef);

		//initialize 
		this.oldInstances = new Array<Instance>();
		this.task = new TaskFrx();
		this.instancesTasks = new Array<TaskFrx>();

		forkJoin([
			this.caseService.getInstance(this._caseid),
			this.taskService.getTasks(this._caseid, false)
		]).subscribe(([instances, tasks]) => {

			// instances
			this.oldInstances = instances;

			// cases 
			this.instancesTasks = tasks;
			for (let i = 0; i < this.instancesTasks.length; i++) {
				let statusTaskBG = '';
				switch (this.instancesTasks[i].statusTask) {
					case 'NOVA': {
						statusTaskBG = 'НОВА';
						break;
					}
					case 'V_PROCESS': {
						statusTaskBG = 'В ПРОГРЕС';
						break;
					}
					case 'IZPULNEN': {
						statusTaskBG = 'ИЗПЪЛНЕНА';
						break;
					}
				}
				this.instancesTasks[i].statusTaskBG = statusTaskBG;
			}

			this.blockUi.stop();

		}, _ => this.blockUi.stop());
	}

	public delete(obj) {
		if (confirm('Сигурни ли сте, че искате да изтриете тази инстанция?')) {
			this.blockUi.start(this.vcRef);
			this.caseService.deleteInstance(obj.id).subscribe(
				result => {
					this.loadData();
					this.blockUi.stop();
				},
				error => {
					this.blockUi.stop();
					alert('Възникна грешка: ' + error.error.message);
				});
		}
	}

	@Input()
	public set editedCase(val: Case) {
		this.edit(val);
	}

	private refresh() {
		this.message = '';
		this.addInstanceText = 'Добави нова инстанция на делото';
		this.instance = new Instance();
	}


	private edit(caseObj: Case): void {
		this.refresh();
		if (caseObj && caseObj.id) {
			this._caseid = caseObj.id;
		}
	}


	prepareCaseDto(instance: Instance): any {
		return {
			...instance,

			// ДАТИ → backend must receive YYYY-MM-DD
			dataNasrochen: this.caseService.toBackendIsoDate(instance.dataNasrochen),
			lihvaDate: this.caseService.toBackendIsoDate(instance.lihvaDate),
			lihvaImushtestvDate: this.caseService.toBackendIsoDate(instance.lihvaImushtestvDate),


			// 🔥 НОВО – призовка
			summonReceivedDate: this.caseService.toBackendIsoDate(
				instance.summonReceivedDate
			),
			zadachaDeadline: this.caseService.toBackendIsoDate(
				instance.zadachaDeadline
			),
		};
	}

	public addInstance() {

		this.instance.lawsuiteId = this._caseid;

		let dto = this.prepareCaseDto(this.instance);

		try {
			this.caseService.addInstance(dto).subscribe(
				result => {
					this.refresh();
					this.loadData();
				},
				error => {
					alert('Възникна грешка: ' + error.error.message);
				});
		} catch (error) {
			this.errorMessage = 'Грешен формат на дата';
			this.blockUi.stop();
		}
	}

	public addTask() {
		if (!this.task.deadline || !this.task.opisanie || !this.task.otgovornik || !this.selectedStatus) {
			alert('Тази задача не е правилно попълнена!');
			return;
		}
		this.blockUi.start(this.vcRef);
		this.task.statusTask = this.selectedStatus.name;
		this.instancesTasks = new Array<TaskFrx>();
		this.taskService.addTask(this.task, this._caseid, false).subscribe(lst => {
			this.instancesTasks = lst;
			this.loadData();
			this.task = new TaskFrx();
			this.blockUi.stop();
		},
			error => {
				this.blockUi.stop();
			});
	}

	public removeTask(t) {
		if (!confirm('Сигурни ли сте, че искате да изтриете тази задача?')) {
			return;
		}
		this.blockUi.start(this.vcRef);
		this.taskService.deleteTask(t.id).subscribe(result => {
			alert('Задачата е изтрита успешно!');
			this.loadData();
			this.blockUi.stop();
		},
			error => {
				this.blockUi.stop();
			});
	}

	copyInstance(row: Instance) {
		this.instance = row;
		if (row.dataNasrochen && row.dataNasrochen != "") {
			this.instance.dataNasrochen = this.datePipe.transform(new Date(row.dataNasrochen), 'dd.MM.yyyy');
		}
		else {
			this.instance.dataNasrochen = "";
		}
		if (row.lihvaDate && row.lihvaDate != "") {
			this.instance.lihvaDate = this.datePipe.transform(new Date(row.lihvaDate), 'dd.MM.yyyy');
		}
		else {
			this.instance.lihvaDate = "";
		}
		if (row.lihvaImushtestvDate && row.lihvaImushtestvDate != "") {
			this.instance.lihvaImushtestvDate = this.datePipe.transform(new Date(row.lihvaImushtestvDate), 'dd.MM.yyyy');
		}
		else {
			this.instance.lihvaImushtestvDate = "";
		}

		this.message = 'В момента редактирате инстанция!';
		this.addInstanceText = 'Запиши дадената инстанция';

		// 🔥 дата на получаване на призовка
		if (row.summonReceivedDate) {
			this.instance.summonReceivedDate =
				this.datePipe.transform(
					new Date(row.summonReceivedDate),
					'dd.MM.yyyy'
				);
		} else {
			this.instance.summonReceivedDate = null;
		}

		// 🔥 срок
		this.instance.summonTermDays = row.summonTermDays;

		// задача deadline
		if (row.zadachaDeadline) {
			this.instance.zadachaDeadline =
				this.datePipe.transform(new Date(row.zadachaDeadline), 'dd.MM.yyyy');
		} else {
			this.instance.zadachaDeadline = null;
		}
	}

	clear() {
		this.refresh();
	}

	compareFrxObjects(o1: FrxBaseBean, o2: FrxBaseBean) {
		if (o1 && o2) {
			return o1.id === o2.id;
		}
	}

	isResolvedStatus(): boolean {
		if (!this.instance || !this.instance.status) {
			return false;
		}

		return this.instance.status.statusReshen === true;
	}


	isSummonDeadlineRequired(): boolean {
		if (!this.instance || !this.instance.status) {
			return false;
		}

		return this.instance.status.deklaracijaChlen83 === true
			|| this.instance.status.plashtaneDarjavnaTaksa === true;
	}

	isZadachaStatus(): boolean {
		if (!this.instance || !this.instance.status) {
			return false;
		}
		return this.instance.status.zadacha === true;
	}

	onStatusChanged() {
		if (!this.isSummonDeadlineRequired()) {
			this.instance.summonReceivedDate = null;
			this.instance.summonTermDays = null;
		}
		if (!this.isZadachaStatus()) {
			this.instance.zadachaDeadline = null;
		}
	}

	private loadInstTemplates() {
		this.wordTemplateService.findByType('GRAZHDANSKA_INSTANCIJA').subscribe(
			data => this.instTemplates = data,
			err => { }
		);
	}

	generateDocument() {
		if (!this.selectedInstTemplate || !this._caseid || !this.instance || !this.instance.id) {
			alert('Моля, изберете инстанция от историята и шаблон');
			return;
		}
		this.blockUi.start(this.vcRef);
		this.wordTemplateService.generateDocument(this.selectedInstTemplate.id, this._caseid, this.instance.id).subscribe(
			resp => {
				this.blockUi.stop();
				const blob = resp.body;
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = this.selectedInstTemplate.name + '_generated.docx';
				a.click();
				window.URL.revokeObjectURL(url);
			},
			err => {
				this.blockUi.stop();
				alert('Грешка при генериране на документ');
			}
		);
	}

}